import security from './security'
import user from './user'
import rules from './rules'
import profile from './profile'
import durations from './durations'
import dialog from './dialog'
import dashboard from './dashboard'
import applicationSettings from './application-settings'
import accessPlatform from './access-platform'
import common from 'src/i18n/en/common'

export default {
  common,
  security,
  user,
  rules,
  profile,
  durations,
  dialog,
  dashboard,
  applicationSettings,
  accessPlatform
}
